﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.BrowserTabService
 * @description
 * # BrowserTabService
 * Service in the ntmApp.
 */


angular.module('ntmApp')
  .factory('BrowserTab', ['Constants', 'Title', function (Constants, Title) {
      
      var service = { Tab: { } };
      
        
      Object.defineProperty(service.Tab, 'tabName', {
              get: function () {
                  return Title.getTitle();
              },
              set: function (name) {
                  Title.setTitle(name);
              }
      });

      return service;

  }]);